var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content content-full font-size-sm text-muted text-center"},[_c('strong',[_vm._v(_vm._s(_vm.yearRange)+" © "),_c('span',{attrs:{"data-toggle":"year-copy"}}),_vm._v("Agritek 26 S.r.l.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }